export const COLORS_IN_LIST = 8;
